module.exports = __webpack_public_path__ + "img/code1.e49d5a7a.png";